import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from '../core';
import { HandleError, HttpErrorHandler } from '../http-error-handler.service';

@Injectable({
    providedIn: 'root'
})
export class DataService {

    private apiServer = '';
    private handleError: HandleError;

    constructor(
        private apiService: ApiService, httpErrorHandler: HttpErrorHandler
    ) {
        this.apiServer = environment.settings.apiServer;
        this.handleError = httpErrorHandler.createHandleError('DataService');
    }

    async getIconosData(): Promise<any> {
        return this.getIconos();
    }

    async getInstitucionesFinancierasData(): Promise<any> {
        return this.getInstitucionesFinancieras();
    }

    async getPlanCaracteristicasData(): Promise<any> {
        return this.getPlanCaracteristicas();
    }
    
    async getPlanesJSONData(): Promise<any> {
        return this.getPlanesJSON();
    }

    async getTareasJSONData(): Promise<any> {
        return this.getTareasJSON();
    }

    async getEstablishmentsJSONData(): Promise<any> {
        return this.getEstablishmentsJSON();
    }

    getIconos() {
        return this.apiService.get('assets/demo/data/iconos.json')
            .toPromise()
            .then(res => res.data as any[])
            .then(data => data);
    }

    getInstitucionesFinancieras() {
        return this.apiService.get('assets/demo/data/instituciones-financieras.json')
            .toPromise()
            .then(res => res.data as any[])
            .then(data => data);
    }

    getPlanCaracteristicas() {
        return this.apiService.get('assets/demo/data/fazil-plan-caracterisiticas.json')
            .toPromise()
            .then(res => res.data as any[])
            .then(data => data);
    }
    
    getTareasJSON() {
        return this.apiService.get('assets/demo/data/tareas.json')
            .toPromise()
            .then(res => res.data as any[])
            .then(data => data);
    }

    getEstablishmentsJSON() {
        return this.apiService.get('assets/demo/data/establecimientos.json')
            .toPromise()
            .then(res => res.data as any[])
            .then(data => data);
    }
    
    getPlanesJSON() {
        return this.apiService.get('assets/demo/data/fazil-planes.json')
            .toPromise()
            .then(res => res.data as any[])
            .then(data => data);
    }

}
